import * as React from 'react'

/**
 * Renders a shield with exclamation mark SVG icon
 * @returns {JSX.Element} Shield icon SVG element
 */
function Shield() {
  return (
    <svg
      fill='none'
      height={22}
      viewBox='0 0 22 26'
      width={22}
    >
      <path
        d='M1.25 4.923v7.614c0 4.926 3.034 9.344 7.632 11.113l1.04.4v0a3 3 0 002.155 0l1.04-.4h0a11.907 11.907 0 007.633-11.113V4.923v0a1.487 1.487 0 00-.868-1.362h0A21.7 21.7 0 0011 1.75h0a21.7 21.7 0 00-8.882 1.811h0a1.487 1.487 0 00-.868 1.362h0z'
        stroke='var(--shield__component__stroke__color)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
      />
      <path
        d='M11 16.5v0a.375.375 0 11-.375.375v0c0-.207.168-.375.375-.375 0 0 0 0 0 0M11 13.25v-5.5'
        stroke='var(--shield__component__stroke__color)'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Shield
